module.exports = __webpack_public_path__ + "static/media/Mark-Pro-Medium.b155b855.otf";